import { render, staticRenderFns } from "./payModel.vue?vue&type=template&id=76724761&scoped=true&"
import script from "./payModel.vue?vue&type=script&lang=js&"
export * from "./payModel.vue?vue&type=script&lang=js&"
import style0 from "./payModel.vue?vue&type=style&index=0&id=76724761&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76724761",
  null
  
)

export default component.exports